﻿import { DestinationPageGallery } from './Swipers.js'; 

$(function () {
    if (typeof Swiper !== 'undefined') {
        /* SWIPERS */
        if ($('.property-gallery').length > 0) {
            var galleryCount = $('.property-gallery .swiper-slide').length;
            var propertySwiper = new Swiper('.property-gallery', {
                spaceBetween: 8,
                preventClicksPropagation: true,
                preventClicks: false,
                navigation: {
                    prevEl: '.property-gallery-nav-prev',
                    nextEl: '.property-gallery-nav-next',
                },
                loop: true,
                loopedSlides: galleryCount,
                lazy: {
                    enabled: true,
                    checkInView: true,
                    loadPrevNext: true,
                    loadPrevNextAmount: 2,
                },
                on: {
                    resize: function () {
                        this.updateSize()
                    }
                }
            });

            var propertyThumbsSwiper = new Swiper('.property-gallery-thumbs', {
                spaceBetween: 8,
                slidesPerView: 'auto',
                loop: true,
                loopedSlides: galleryCount,
                touchRatio: 0.5,
                slideToClickedSlide: true,
                watchSlidesProgress: true,
                lazy: {
                    enabled: true,
                    checkInView: true,
                    loadPrevNext: true,
                    loadPrevNextAmount: 4,
                    loadOnTransitionStart: true,
                },
                on: {
                    resize: function () {
                        this.updateSize()
                    }
                }
            });

            propertySwiper.controller.control = propertyThumbsSwiper;
            propertyThumbsSwiper.controller.control = propertySwiper;
        }
        if ($('.destination-gallery').length > 0) {
            var destinationSwiper = new Swiper('.destination-gallery', {
                preventClicksPropagation: true,
                preventClicks: false,
                navigation: {
                    prevEl: '.destination-gallery .swiper-nav-prev',
                    nextEl: '.destination-gallery .swiper-nav-next',
                },
                pagination: '.destination-gallery .swiper-pagination',
                paginationClickable: true,
                loop: true,
                auto: true
            });
        }

        if ($('.property-events').length) {
            $('.events-pagination-wrap:eq(0)').addClass('active');
            var totalEventPages = parseInt($('.events-pagination-wrap').length);

            $('.property-events nav.prev-next li.next a').click(function () {
                currentEventPage = parseInt($('.events-pagination-wrap.active').index());

                if ((currentEventPage + 1) == totalEventPages) {
                    $('.property-events nav.prev-next li.next').addClass('disabled-link');
                } else {
                    nextPage = parseInt(currentEventPage + 1);

                    $('.events-pagination-wrap.active').removeClass('active');
                    $('.events-pagination-wrap:eq(' + nextPage + ')').addClass('active');

                    if ((nextPage + 1) == totalEventPages) {
                        //Last one so disabled next button
                        $('.property-events nav.prev-next li.next').addClass('disabled-link');
                    }
                    if (totalEventPages > 0) {
                        $('.property-events nav.prev-next li.prev').removeClass('disabled-link');
                    }
                }
            });
            $('.property-events nav.prev-next li.prev a').click(function () {
                currentEventPage = parseInt($('.events-pagination-wrap.active').index());

                if ((currentEventPage) == 0) {
                    $('.property-events nav.prev-next li.prev').addClass('disabled-link');
                } else {
                    prevPage = parseInt(currentEventPage - 1);

                    $('.events-pagination-wrap.active').removeClass('active');
                    $('.events-pagination-wrap:eq(' + prevPage + ')').addClass('active');

                    if (prevPage == 0) {
                        //Last one so disabled next button
                        $('.property-events nav.prev-next li.prev').addClass('disabled-link');
                    }
                    if (totalEventPages > 0) {
                        $('.property-events nav.prev-next li.next').removeClass('disabled-link');
                    }
                }
            });
        }
    }

    /* TABS */


    var loadPropertyTab = function (tab) {
        // remove hash if present
        if (tab.indexOf('#') == 0) tab = tab.substring(1);
        if (tab.length == 0) tab = 'overview';

        if ($('.property-tab-' + tab).length) {
            $('.property-tab').removeClass('active');
            $('.property-tab-' + tab).addClass('active');

            $('.property-tabs li').removeClass('active');
            $('.property-tabs li[rel=' + tab + ']').addClass('active');
        }

        // update swipers
        switch (tab) {
            case 'location':
                if ($('.destination-gallery').length > 0) {
                    destinationSwiper.update();
                } else if ($('.destinationGallery').length > 0) {
                    DestinationPageGallery.update();
                }
                break;
            case 'mapview':
                loadTheMap();
        }

        // load defered images
        $('img.defered-image--' + tab).each(function () {
            var src = $(this).attr('data-src');
            $(this).attr('src', src);
        });
    };


    //set tab on click
    $('a[href^="#"]').click(function (e) {
        var newtab = $(this).attr('href');
        if (newtab.indexOf('#') == 0) newtab = newtab.substring(1);
        loadPropertyTab(newtab);
        recordPageView(newtab);
        return true;
    });
    function recordPageView(page) {
        if (typeof page !== 'undefined') {
            var virtualURL = document.location.href.split('#')[0];
            page = page || 'overview';
            virtualURL += '/' + page;
            dataLayerQueue.push({ 'event': 'pageView', 'virtualPageURL': virtualURL });
        }
    }

    $('a[href^="#"].jump-nav').click(function (e) {
        $('html, body').animate({
            scrollTop: $(".property-tabs").offset().top
        }, 100);
    });

    //set tab on load

    loadPropertyTab(document.location.hash);
    let activeTab = $('.property-tabs li.active').attr('rel');
    recordPageView(activeTab)

    //remove anchors
    $('.property-tabs li').each(function () {
        $('a[name=' + $(this).attr('rel') + ']').remove();
    });


    if ($('.unique-and-boutique-property') && $('.property-topreviews')) {
        $('.unique-and-boutique-property').css('background', 'none');
    }

    $('a.share-modal').click(function (e) {
        e.preventDefault();
        var newwindow = window.open($(this).attr('href'), 'PropertyShare', 'menubar=no,location=no,resizable=no,scrollbars=no,status=no,height=400,width=500');
        if (window.focus) { newwindow.focus(); }
        console.log('opened');
        return false;
    });


    $('.property-complex .complex-carousel').each(function () {
        if (typeof Swiper !== 'undefined') {
            var thisSwiper = new Swiper(this, {
                slidesPerView: 'auto',
                spaceBetween: 20,
                autoHeight: false,
                navigation: {
                    prevEl: '.result-nav div.prev',
                    nextEl: '.result-nav div.next',
                },
                pagination: '.swiper-pagination',
                paginationClickable: true,
                loop: false
            });
        }
    });


});